import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

export function configureStore(initialState, reducer, config) {
	return createStore(
		reducer,
		initialState,
		compose(
			applyMiddleware(thunk),
			window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && config.environment.indexOf('dev') >= 0
				? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
				: f => f,
		),
	);
}
